<script>
import AcDataTableBulkRmv from "@/components/Table/ac-data-table-bulk-rmv.vue";
import AcDataTableToolbar from "@/components/Table/ac-data-table-toolbar.vue";

export default {
  name: 'AcDataTable',
  inheritAttrs: false,
  components: { AcDataTableBulkRmv, AcDataTableToolbar },

  model: { prop: 'value', event: 'input' },

  props: {
    value: { type: Array, default: () => [] },
    search: { type: String, default: '' },

    canSelect: { type: Function, default: () => true },
    canDelete: { type: Function, default: () => true },

    // old: single delete
    remove: { type: Function, default: null },

    //NEW: bulk delete (one request)
    removeBulk: { type: Function, default: null },

    showBulk: { type: Boolean, default: true },
    bulkMode: { type: Boolean, default: false },

    title: { type: String, default: 'Table' },
    searchLabel: { type: String, default: 'Search' },

    bulkDeleteLabel: { type: String, default: 'Bulk delete' },
    emptyMsg: { type: [String, Function], default: 'Select item(s) to delete' },
    confirmMsg: { type: Function, default: (n) => `Delete ${n} selected item(s)?` },
    successMsg: { type: String, default: 'Changes was published' },
    alertTitle: { type: String, default: 'Bulk delete' },

    selectColor: { type: String, default: 'red' },
    selectOffIcon: { type: String, default: 'mdi-checkbox-blank-outline' },
    selectOnIcon:  { type: String, default: 'mdi-checkbox-marked' },
  },

  watch: {
    bulkMode(val) {
      if (!val && this.value && this.value.length) {
        this.$emit('input', []);
      }
    }
  },

  methods: {
    toggleBulk() {
      this.$emit('update:bulkMode', !this.bulkMode);
    }
  },

  render(h) {
    const effectiveBulkMode = this.showBulk ? this.bulkMode : false;

    const topSlot = () => h(
        'ac-data-table-toolbar',
        {
          props: {
            title: this.title,
            search: this.search,
            searchLabel: this.searchLabel,
            showBulk: this.showBulk,
            bulkMode: this.bulkMode,
            bulkDeleteLabel: this.bulkDeleteLabel,

            selected: this.value,
            canDelete: this.canDelete,

            remove: this.remove,
            removeBulk: this.removeBulk,

            emptyMsg: this.emptyMsg,
            confirmMsg: this.confirmMsg,
            successMsg: this.successMsg,
            alertTitle: this.alertTitle,
          },
          on: {
            'update:search': v => this.$emit('update:search', v),
            'update:bulkMode': v => this.$emit('update:bulkMode', v),
            'clear-selection': () => this.$emit('input', []),
            'bulk-delete': () => this.$emit('bulk-delete'),
          },
          scopedSlots: {
            actions: this.$scopedSlots.actions,
            'bulk-extra': this.$scopedSlots['bulk-extra'],
            'search-prepend': this.$scopedSlots['search-prepend'],
            'search-append': this.$scopedSlots['search-append'],
          }
        }
    );

    const passthroughSlots = { ...this.$scopedSlots };
    delete passthroughSlots.top;

    const table = h(
        'ac-data-table-bulk-rmv',
        {
          attrs: this.$attrs,
          props: {
            ...this.$attrs,
            value: this.value,
            bulkMode: effectiveBulkMode,
            canSelect: this.canSelect,
            selectColor: this.selectColor,
            selectOffIcon: this.selectOffIcon,
            selectOnIcon: this.selectOnIcon,
            search: this.search,
          },
          on: {
            ...this.$listeners,
            input: v => this.$emit('input', v),
          },
          scopedSlots: {
            top: topSlot,
            ...passthroughSlots,
          }
        }
    );

    return h('section', { staticClass: 'ac-data-table-wrapper' }, [table]);
  }
}
</script>
